import { request } from "../../Services/Api"

export const getPerks = (params) => request.api.get("/restful_api/perks/", params)
